// profile/MyProfilePage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import ProfileHeader from './ProfileHeader';
import ProfileTabs from './ProfileTabs';
import ProfileTabContent from './ProfileTabContent';
import { TAB, TABS_BY_ROLE } from './tabs';
import { useTranslation } from 'react-i18next';

const MyProfilePage = () => {
  const { user } = useAuth();
  const { t } = useTranslation('profile');

  const defaultTab = useMemo(() => {
    if (!user?.role) return TAB.GALLERY;
    const tabs = TABS_BY_ROLE[user.role] || [];
    return tabs[0] || TAB.GALLERY;
  }, [user?.role]);

  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    if (!user?.role) return;
    const validTabs = TABS_BY_ROLE[user.role] || [];
    const shouldReset = !activeTab || !validTabs.includes(activeTab);
    if (shouldReset) setActiveTab(validTabs[0] || TAB.GALLERY);
  }, [user?.role]);

  if (!user) return <div>{t('loading')}</div>;

  return (
    <div>
      <ProfileHeader user={user} isOwner={true} />
      <ProfileTabs userRole={user.role} isOwner={true} activeTab={activeTab} setActiveTab={setActiveTab} />
      <ProfileTabContent user={user} isOwner={true} activeTab={activeTab} />
    </div>
  );
};

export default MyProfilePage;
